import React, { createContext, useContext } from 'react';
import type { NamespaceFormats } from './namespaceFormats';

const NamespaceFormatsContext = createContext<NamespaceFormats>({
  editor: [],
  publicEditor: [],
  postPreview: [],
  embedPostContent: [],
  history: [],
  embedded: [],
  tableCell: [],
  code: [],
  comment: [],
  annotation: [],
  searchInput: [],
  topicUserDescription: [],
  organizationSummary: [],
  embeddedTableCell: [],
});

export const useNamespaceFormats = () => useContext(NamespaceFormatsContext);

type NamespaceFormatsProviderProps = {
  children: React.ReactNode;
  namespaceFormats: NamespaceFormats;
};

const NamespaceFormatsProvider = ({
  children,
  namespaceFormats,
}: NamespaceFormatsProviderProps) => {
  return (
    <NamespaceFormatsContext.Provider value={namespaceFormats}>
      {children}
    </NamespaceFormatsContext.Provider>
  );
};

export default NamespaceFormatsProvider;
